import React from "react";
import { Route, Redirect } from "react-router-dom";

// Check if user is authenticated
const isAuthenticated = () => {
  return !!localStorage.getItem("token"); // Check if token exists
};

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? <Component {...props} /> : <Redirect to="/login" />
    }
  />
);

export default PrivateRoute;
